module.exports = __webpack_public_path__ + "static/img/p4.26bf2f63.png";